import axios from 'axios'
export default async () => {
    let backend= "https://api-dashboard.oned.io"
    let backend2= "http://localhost:3000"
    
    let return_value=await axios.get(`${backend}/traffic/getUniqueAttributes`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      })
      return return_value
}